import HCLDX from "@system/config/hcldx";
import Cookies from "js-cookie";
import moment from "moment";
import RoleAndPermission from "src/helper/RoleAndPermission";
import System from "src/helper/system";
import { isArray, isNumber, isString } from "underscore";

class Helper {
    static getBaseUrl() {
        return this.getUserUrl();
    }

    static getBOMUrl() {
        return process.env.REACT_APP_API_BOM;
    }

    static getDesignHubUrl() {
        return process.env.REACT_APP_API_DESIGN_HUB;
    }

    static getApplicationUrl() {
        return process.env.REACT_APP_API_APPLICATION;
    }

    static getCartUrl() {
        return process.env.REACT_APP_API_CART;
    }

    static getInventoryUrl() {
        return process.env.REACT_APP_API_INVENTORY;
    }

    static getPCNUrl() {
        return process.env.REACT_APP_API_PCN;
    }

    static getPCNExportUrl() {
        return process.env.REACT_APP_API_PCN_EXPORT;
    }

    static getPriceUrl() {
        return process.env.REACT_APP_API_PRICE;
    }

    static getProductUrl() {
        return process.env.REACT_APP_API_PRODUCT;
    }

    static getUserUrl() {
        return process.env.REACT_APP_API_USER;
    }

    static getVatUrl() {
        return process.env.REACT_APP_API_VAT;
    }

    static getForecastUrl() {
        return process.env.REACT_APP_API_FORECAST;
    }

    static getProfileUrl() {
        return process.env.REACT_APP_API_USER;
    }

    static getAutosuggestUrl() {
        return process.env.REACT_APP_API_AUTOSUGGEST;
    }

    static getBrowseTabsUrl() {
        return process.env.REACT_APP_API_BROWSE_TABS;
    }

    static getOrderUrl() {
        return process.env.REACT_APP_API_ORDER;
    }

    static getReportErrorUrl() {
        return process.env.REACT_APP_API_REPORT_ERROR;
    }

    static getAdminConsoleUrl() {
        return process.env.REACT_APP_API_ADMIN_CONSOLE;
    }

    static UUID() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    static rangToArray(min, max) {
        var range = [];
        for (let i = min; i <= max; i++) {
            range.push(i);
        }
        return range;
    }

    static bytesToMB(bytes) {
        return bytes / (1024 ** 2);
    }

    static getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    static checkJSON(jsonString) {
        try {
            let o = JSON.parse(jsonString);

            // Handle non-exception-throwing cases:
            // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
            // but... JSON.parse(null) returns null, and typeof null === "object",
            // so we must check for that, too. Thankfully, null is falsey, so this suffices:
            if (o && typeof o === "object") {
                return o;
            }
        } catch (e) {
        }

        return false;
    };

    static scrollTop() {
        window.scrollTo(0, 0);
    }

    // Need to optimize
    static getCurrencyFormat(currencyType) {
        let format = '';
        switch (currencyType) {
            case 'CHF':
                format = 'nb-NB';
                break;
            case 'CZK':
                format = 'nb-NB';
                break;
            case 'DKK':
                format = 'nb-NB';
                break;
            case 'EUR':
                format = 'nl-NL';
                break;
            case 'GBP':
                format = 'en-GB';
                break;
            case 'HKD':
                format = 'zh-HK';
                break;
            case 'ILS':
                format = 'nb-NB';
                break;
            case 'JPY':
                format = 'ja-JP';
                break;
            case 'NOK':
                format = 'nb-NB';
                break;
            case 'PLN':
                format = 'nb-NB';
                break;
            case 'RON':
                format = 'rof';
                break;
            case 'SEK':
                format = 'nb-NB';
                break;
            case 'TRY':
                format = 'tr-TR';
                break;
            case 'ZAR':
                format = 'en-ZA';
                break;
            default:
                format = 'en-US';
                break;
        }
        return format;
    }

    // Need to optimize
    static getFormatNumber(amount, currency = window.mct, symbol = window.mcs, maximumFractionDigits = 2, isSymbol = true, isDisplaySymbol = true) {
        try {
            if (amount !== undefined && isNumber(amount) && currency !== undefined) {
                let formatAmount = isSymbol ? new Intl.NumberFormat(Helper.getCurrencyFormat(currency), {
                    style: 'currency',
                    maximumFractionDigits: maximumFractionDigits,
                    currency: currency,
                    currencyDisplay: 'narrowSymbol'
                }).format(amount).replace(/\s/g, "") :

                    new Intl.NumberFormat(Helper.getCurrencyFormat(currency), {
                        style: 'currency',
                        currency: currency,
                        maximumFractionDigits: maximumFractionDigits
                    }).formatToParts(amount).map(
                        p => p.type != 'literal' && p.type != 'currency' ? p.value : ''
                    ).join('').replace(/\s/g, "").trim();

                /** 10807  Currency having same symbol ex: CHF those symbol will replace and single symbol we'll display - Pankaj - 28 April 2023 */
                if ((isSymbol === false || isDisplaySymbol === false) && formatAmount.includes(currency)) {
                    return formatAmount.replace(currency, '')
                }
                return formatAmount;
            } else {
                return symbol + '' + amount;
            }
        } catch (err) {
            return symbol + '' + amount;
        }
    }

    static getLongDateFormat(date, isForecast = false) {
        try {
            if (isForecast) {
                return new Date().toLocaleString('en-us', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
            }
            return new Date(date).toLocaleString('en-us', { year: "numeric", month: "long", day: "numeric" })
        } catch (err) {
            return date;
        }
    }

    /** 8905,9153,12192 - Date format changes in all listing pages & single digit issue in listing - Pankaj - 09 Feb 2023     */
    static dateFormatFromString(date, isDate = false, isBOM = false) {
        try {
            if (isDate) {
                if (isBOM) {
                    return new moment.utc(date).local().format("HH:mm, MMMM DD, YYYY");
                }
                return new Date(date).toLocaleString('en-us', { year: "numeric", month: "long", day: "2-digit" })
            }

            if (!isString(date)) {
                date = date.toString()
            }

            if (isNumber(parseInt(date)) && parseInt(date) > 9999) {
                let year = date.substring(0, 4);
                let month = date.substring(4, 6);
                let dates = date.substring(6, 99);
                let dateVal = new Date(year, (month - 1), dates);  // 2009-11-10
                let monthText = dateVal.toLocaleString('default', { month: 'long' });
                let finalRes = monthText + ' ' + dates + ', ' + year
                return finalRes
            }
            return ''
        }
        catch (err) {
            return date;
        }
    }

    static getStandardDateFormat(date) {
        var today = new Date(date);
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();

        return mm + '/' + dd + '/' + yyyy;
    }

    static checkValidURL(url) {
        var elm;
        if (url !== "") {
            if (!elm) {
                elm = document.createElement('input');
                elm.setAttribute('type', 'url');
            }
            elm.value = url;
            return elm.validity.valid;
        } else {
            return false
        }
    }

    static getSkipCount(current_page, limit) {
        let skip = limit * (current_page - 1);
        if (skip === null) {
            skip = 0;
        }
        if (!skip) {
            skip = 0;
        }
        if (skip === '') {
            skip = 0;
        }
        if (skip < 0) {
            skip = 0;
        }
        return skip;
    }

    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    static handlePageClick(data, pageCount) {
        let here_page = 0
        here_page = data.selected + 1;
        return here_page;
    }

    /** 8529 - Common Date format for all datepicker - Pankaj - 07th Feb 2023      */
    static getDatepickerFormat() {
        return "MMMM dd, yyyy"
    }

    // Need to optimize
    static getTrackingCarrier(carrier) {
        let carrierUrl = '';
        if (carrier && carrier.trim() !== '') {
            switch (carrier.toUpperCase()) {
                case 'UPS':
                    carrierUrl = 'http://wwwapps.ups.com/etracking/tracking.cgi?submit=Track&InquiryNumber2=&InquiryNumber3=&InquiryNumber4=&InquiryNumber5=&TypeOfInquiryNumber=T&InquiryNumber1='
                    break;
                case 'FEDEX':
                    carrierUrl = 'http://www.fedex.com/Tracking?action=track&language=english&cntry_code=us&mps=y&tracknumbers='
                    break;
                case 'DHL':
                    carrierUrl = 'http://www.dhl.com/publish/g0/en/eshipping/track.high.html?pageToInclude=RESULTS&type=fasttrack&AWB='
                    break;
                default:
                    carrierUrl = '';
                    break;
            }
        }
        return carrierUrl;
    }

    // // need to use from system sonstant
    // static getSpeedboatFullName = () => {
    //     let _sBoat = System.getCurrentSiteSpeedboatShortName();
    //     let speedboatText = '';
    //     switch (_sBoat) {
    //         case 'T': speedboatText = 'Abacus'; break;
    //         case 'B': speedboatText = 'EBV'; break;
    //         case 'S': speedboatText = 'Silica'; break;
    //         default: speedboatText = ''; break;
    //     }
    //     return speedboatText;
    // }

    static getHCLDXBaseUrlHost = () => {
        let _baseUrl = HCLDX.get_REACT_APP_HCL_DX_BASE_URL();
        if (_baseUrl !== undefined && _baseUrl !== '') {
            let _url = new URL(_baseUrl);
            if (_url && _url.hostname !== undefined) {
                return _url.hostname;
            }
        }
        return window.location.host;
    }

    static getCurrentCurrency = () => {
        return window.mct;
    }

    //Create function to check value is null/empty or not
    static valueIsNotNull = (value) => {
        if (value && value !== undefined && value !== null && value.toString().trim() !== "")
            return true
        else
            return false
    }

    /**
     * Change    : Common function to get authorization token
     * Change by : Hardik Sarodiya
     */
    // static getAuthorizationToken() {
    //     return 'Bearer ' + document.getElementById("randomVal")?.value;
    // }

    /**
     * Change    : Common function to get subscription key (Ocp-Apim-Subscription-Key)
     * Change by : Hardik Sarodiya
     */
    static getOcpApimSubscriptionKey() {
        if (['my.avnet.com', 'hcl-dep-prd-passthrough-hcl-dep-prd.apps.avtaroweuprd.avnet.com'].includes(window.location.host)) { // PRODUCTION
            return '6d27fed17f7d4deb8faddff4870bf910';
        } else if (['my.dev.avnet.com', 'weu-dep-dev1-passthrough-avt-weu-dep-dev1.apps.avtarowu3npr.avnet.com'].includes(window.location.host)) { // DEV
            return '7862c28511c34499bb097583cc8df5a4';
        } else { // SBX,TEST and UAT
            return 'a351df08b15f4b61a455346984a69855';
        }
    }

    /** Common header function to set header in APIs - Hardik Sarodiya - Pankaj Nihalani - 02 March 2023     */
    static getCommonHeader(method, contentType = '', acceptType = '') {
        let reqType = {
            GET: 'GET, OPTIONS',
            POST: 'POST, OPTIONS',
            PUT: 'PUT, OPTIONS',
            DELETE: 'DELETE, OPTIONS'
        }
        return {
            'accept': acceptType !== '' ? acceptType : 'text/plain',
            'Content-Type': contentType !== '' ? contentType : 'application/json-patch+json',
            'avUserInfo': System.getCurrentAvuserInfoCookie(),
            // 'Authorization': 'Bearer ' + document.getElementById("randomVal")?.value,
            'Authorization': 'Bearer ' + Cookies.get('apt_em'),
            'Ocp-Apim-Subscription-Key': this.getOcpApimSubscriptionKey(),
            'Access-Control-Allow-Methods': reqType[method.toUpperCase()]
        }
    }

    // need to move to the system
    static isCallFromQuoteCart = () => {
        let currentUrl = window.location.pathname;
        const c = System.getParams();
        const cart = currentUrl.includes("shop")
        if (cart && c.quote_number !== undefined) {
            return true
        }
        return false
    }
    // need to move to the system
    static isCallFromCart = () => {
        let currentUrl = window.location.pathname;
        const cart = currentUrl.includes("shop")
        if (cart) {
            return true
        }
        return false
    }

    // need to move to the system
    static checkIsCustomerPrice = (price) => {
        if (price && price.length === 1 && price[0].priceSource && price[0].priceSource.replace(/\s+/g, '').toUpperCase() === 'CUSTOMERPRICE') {
            return true
        }
        return false
    }

    // need to move to the system
    static removeDuplicateFromObjectByItemNumber = (obj) => {
        return Object.keys(obj)
            .filter((tag, index, array) =>
                array.findIndex(t => obj[t].ItemNumber == obj[tag].ItemNumber) == index
            )
            .reduce((res, key) => (res[key] = obj[key], res), {});
    }

    static validateRegex = (term, expr) => {
        let re = new RegExp(expr);
        if (re.test(term)) {
            return true;
        }
        return false;
    }

    static checkObjectHaveValue = (obj) => {
        return Object.values(obj).every(value => { return value ? false : true })
    }

    static downloadFileFromRes = (data, fileName = "data") => {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    // // need to move to the system
    // static validateUserRole = (role) => {
    //     let roles = System.auth('roles');
    //     if (roles && roles.length > 0 && roles.filter(x => x.toLowerCase() == role).length > 0) {
    //         return true;
    //     }
    //     return false;
    // }
    static toUpperCase = (text) => {
        return text ? text.toUpperCase() : text;
    }
    static toCapitalize = (text) => {
        return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : text;
    }

    // need to move to the system
    static validateDomain = (email) => {
        if (!email) {
            return false;
        }
        if (email.includes('@')) {
            const userDomain = (email.split("@"))[1];
            const domains = ["ebv.com", "avnet.eu", "silica.com", "avnet-abacus.eu", "abacus.co.uk",
                "avnet-embedded.eu", "avnet.com", "AVNETTIME.EU", "avnet-memec.eu", "avnet.abacus.eu", "softwebsolutions.com"];
            const idx = domains.findIndex(f => f.toLowerCase() === userDomain.toLowerCase());
            return idx === -1 ? true : false;
        }
        else {
            return false;
        }
    }

    static textSortingAgGrid = (valueA, valueB) => {
        const argumentA = valueA || '';
        const argumentB = valueB || '';
        return argumentA.localeCompare(argumentB);
    };

    static dateSortingAgGrid = (valueA, valueB) => {
        if (!valueA || !valueB) {
            return !valueA ? -1 : 1;
        }
        return new Date(valueA) - new Date(valueB);
    };
    static calendarAgGridComparator = (valueA, valueB) => {
        if (!valueA || !valueB) {
            return !valueA ? -1 : 1;
        }
        return new Date(valueB) - new Date(valueA);
    };
    static getDatepickerFormatAdminConsole(date) {
        return moment(date).format("MMMM DD, yyyy")
    }

    

    // // need to move to the system
    // static getRoles = () => {
    //     return Object.keys(RoleAndPermission.register)
    // }

    static convertToYYMMDD = (timestamps) => {
        return timestamps.split(';').map(function (timestamp) {
            var parts = timestamp.split('T');
            var datePart = parts[0];
            return datePart;
        }).join(';');
    }

    // need to move to the system
    static monitorJSDx = () => {
        if (window.BOOMR?.plugins?.SPA) {
            window.BOOMR?.plugins?.SPA?.wait_complete();
            console.log("stop BOOMR.plugins.SPA.wait_complete()");
        } else {
            console.log("Not started");
        }
    }

    // need to move to the system
    static setEvars = (itemsId, eventStr) => {
        if (window?.digitalData) {
            if (!window?.digitalData?.transaction) {
                window.digitalData.transaction = {}
            }
            window.digitalData.event.eventinfo.events = eventStr;
            window.digitalData.transaction.items = itemsId;
        }
    }
    static getDateFormatForOrder() {
        const year = inputDate.substring(0, 4);
        const month = parseInt(inputDate.substring(4, 6), 10);
        const day = parseInt(inputDate.substring(6), 10);

        const monthName = new Date(year, month - 1, day).toLocaleString('en', { month: 'long' });
        return `${monthName} ${day < 10 ? '0' : ''}${day}, ${year}`;
    }
    
    // need to move to the constant
    static speedboatMappings = {
        T: "Abacus",
        S: "Silica",
        B: "EBV"
    }

    // need to move to the constant
    static speedboatReverseMappings = {
        Abacus: "T",
        ABACUS: "T",
        Silica: "S",
        SILICA: "S",
        EBV: "B",
    }

    // need to move to the system
    static renderRoles(roles, roleData) {
        let renderedRoleA = '';
        if (isArray(roles) && roles?.length > 0) {
            renderedRoleA = roles.map((role) => {
                const found = roleData.find(r => role === r.roleName);
                if (!found) {
                    return role;
                }
                return `${role}: ${found?.roleDescription}`
            });
            renderedRoleA = renderedRoleA.join(', ');
        }
        return renderedRoleA;
    }

    // need to move to the system
    static numberSortingAgGrid = (valueA, valueB) => {
        return parseFloat(valueB) - parseFloat(valueA)
    };

    static replaceSpecialChar = (inputStr) => {
        if (!inputStr) {
            return '';
        }

        return inputStr.replace(/\+/g, "and")
            .replace(/\&/g, "and")
            .replace(/\./g, "")
            .replace(/\//g, "-")
            .replace(/\,/g, "")
            .replace(/\s/g, "-")
            .replace(/#/g, "")
            .replace(/%/g, "")
            .replace(/\---/g, "-");
    }
    static getBomRematchMessage = () => {
        return 'Define the column headers to match your data. Part Number is required.';
    }
}

export default Helper;